import { MEDIA } from "@/styles/common";
import { createDate, handleDate } from "@/utils";
import { Box, Center, Checkbox, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { CloseButton, CustomButton, CustomFlex } from "./popUp.style";
import { type PopUpProps } from "./popUp.type";

export const PopUp = ({ currentPopUp }: PopUpProps) => {
    const { imgUrl, style, liveHours, fromTo, postIdx } = currentPopUp;
    const { endDate } = fromTo;
    const { width, height } = style;
    const { isMobile } = MEDIA();
    const [isPopUp, setIsPopUp] = useState(true);
    const [isExpired, setIsExpired] = useState(false);
    const getLiveHoursCookie = Cookies.get(`popupHidden_${postIdx}`);

    const handleClose = () => {
        setIsPopUp(false);
    };

    const handlePopUpCookie = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const midnight = dayjs().endOf("day");
            Cookies.set(`popupHidden_${postIdx}`, "true", {
                expires: midnight.toDate(),
                sameSite: "None",
                secure: true,
            });
        }

        if (!e.target.checked) Cookies.remove(`popupHidden_${postIdx}`);
    };

    useEffect(() => {
        const { currentDateInfo } = createDate();
        const { newDateInfo } = handleDate(endDate);
        if (currentDateInfo === newDateInfo) setIsExpired(true);
    }, []);

    return (
        <Center
            position="relative"
            display={isPopUp && !getLiveHoursCookie && !isExpired ? "block" : "none"}
            w={isMobile ? "280px" : `${width}px`}
            h={isMobile ? "280px" : `${height}px`}
        >
            <CloseButton iconNamed="close" onClick={() => handleClose()} />
            <Box w="100%" h="100%" background={`url(${imgUrl}) no-repeat center / cover`} />
            <CustomFlex p="4px 12px">
                <Center columnGap="8px" as="label" cursor="pointer">
                    <Checkbox onChange={handlePopUpCookie} />
                    <Text>{liveHours}시간 동안 열지 않음</Text>
                </Center>
                <CustomButton onClick={() => handleClose()}>창 닫기</CustomButton>
            </CustomFlex>
        </Center>
    );
};
